import {
    ARRIVAL_AIRPORT_SELECTED, ARRIVAL_AIRPORTS_BATCH_RECEIVED, CLEAR_FILTER, PARENT_FILTERS_CHANGED, RESET_ALL_FILTERS,
    SET_SELECTED_URL_FILTERS
} from "../../actions/FlightsActions";

const initialState = {
    airports: {},
    selected: []
};

const ArrivalAirportsFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case ARRIVAL_AIRPORTS_BATCH_RECEIVED:
            return {
                ...state, airports: action.payload
            };
        case ARRIVAL_AIRPORT_SELECTED:
            if (state.selected.indexOf(action.airport) === -1) {
                return {
                    ...state, selected: [...state.selected, action.airport]
                };
            }

            return {
                ...state, selected: state.selected.filter(item => item !== action.airport)
            };
        case SET_SELECTED_URL_FILTERS:
            if (action.name === 'arrivalAirports') {
                return {
                    ...state,
                    selected: action.payload,
                };
            }

            return state;
        case PARENT_FILTERS_CHANGED:
            return {...state, selected: action.filters.arrivalAirports};
        case CLEAR_FILTER:
            if (action.filter === 'arrivalAirports') {
                return {...state, selected: initialState.selected};
            }

            return state;
        case RESET_ALL_FILTERS:
            return {...state, selected: initialState.selected};
        default:
            return state
    }
};

export default ArrivalAirportsFilterReducer;



// WEBPACK FOOTER //
// ./src/reducers/filters/ArrivalAirportsFilterReducer.js